export const LiveEvents = () => {
  return <div id="cemboo-stream-library" style={{ color: "#fff" }}></div>;
};
